import Notifier from "./notify";

export const copyToClipboard = (text, label = "Copied") => {
  if (!text) return;

  navigator.clipboard.writeText(text)
    .then(() => {
      Notifier.info(`${label}: ${text}`);
    })
    .catch(() => {
      Notifier.error("Failed to copy to clipboard");
    });
};
